<template>
  <section class="r-booster-page">
    <ac-data-table
      :headers="headers"
      :items.sync="items"
      :item-class="row_class"
      sort-by="name"
      item-key="uid"
      hide-default-footer
      disable-pagination
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      :show-bulk="false"

      title="Booster"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Item
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.enabled="{item}">
        <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>
    <r-booster-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </section>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {BoosterModel} from "@/modules/redactor/models/booster/BoosterModel";

import RBoosterDialog from "@/modules/redactor/views/booster/r-booster-dialog.vue";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";

export default {
  components: {RDialogPreviewCollection, AcDataTable, RBoosterDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Key", value: "key"},
      {text: "Name", value: "name"},
      {text: "Kind", value: "kind.name"},
      {text: "Status", value: "enabled"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(BoosterModel)
    },
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy()).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushBooster(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushBooster(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushBooster(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeBooster(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },
    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushBooster(result);
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },

    row_duplicate(item) {
      return this.items.find(v => {
        return v.kind.equal(item.kind) && v.uid !== item.uid;
      });
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, BoosterModel, "booster")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getBoosters();
  }
};
</script>